<organization-select    #orgManager
                        autoSelectFirst = "true"
                        class           = "mr-3"
                        ></organization-select> 

<site-select            #siteManager
                        [org]           = "orgManager?.currentValue"
                        enabled         = "0"
                        autoSelectFirst = "true"
                        (change)        = "siteChange($event)"
                        class           = "mr-3"></site-select>

<br>

<help-alert 
                        text        = "help.page.auto_model.text" 
                        description = "help.page.auto_model.description" 
                        info        = "help.info"></help-alert>

<br>
<br>

<button type="button" class="btn btn-outline-secondary mr-3 mb-3" (click) = "gotoModels()"  translate>pages.slotautomate.models</button>
<button type="button" class="btn btn-outline-secondary mr-3 mb-3" (click) = "applyModel()"  translate>pages.slotautomate.apply</button>

<br>
<br>

<custom-table           #slotAutomateTable

                        table_id            =   "slotAutomateTable"
                        no_title_value      =   "tables.slotautomate.no_title_value"
                        title_single        =   "tables.slotautomate.title_single"
                        title_multiple      =   "tables.slotautomate.title"
                        filter_title        =   "tables.slotautomate.filter_title"
                        search_title        =   "tables.slotautomate.search_title"
                        [columns]           =   "slotautomateColumns"
                        [values]            =   "values"
                        [parent]            =   "this"
                        [create]            =   "false"
                        [update]            =   "false"
                        [buttons]           =   "buttons"
                        [filter_columns]    =   "false"></custom-table>
